import { render, staticRenderFns } from "./ships-confirm-input.vue?vue&type=template&id=d88d06d2&scoped=true&"
import script from "./ships-confirm-input.vue?vue&type=script&lang=js&"
export * from "./ships-confirm-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88d06d2",
  null
  
)

export default component.exports